"use client";

import * as React from "react";
import { addAction, initBrowserTracing } from "./hyperdx-browser";

const TracingContext = React.createContext({ addAction });

export function HyperDXTracingProvider({
  children,
  apiKey,
  service,
}: {
  children: React.ReactNode;
  apiKey?: string;
  service: string;
}) {
  initBrowserTracing({ apiKey, service });
  return <TracingContext.Provider value={{ addAction }}>{children}</TracingContext.Provider>;
}

export function useHyperDXTracer() {
  const context = React.useContext(TracingContext);
  if (!context) {
    throw new Error("useHyperDXTracer must be used within a HyperDXTracingProvider");
  }
  return context;
}
